import { render, staticRenderFns } from "./data.vue?vue&type=template&id=3d31d8ed&scoped=true&"
import script from "./data.vue?vue&type=script&lang=js&"
export * from "./data.vue?vue&type=script&lang=js&"
import style0 from "./data.vue?vue&type=style&index=0&id=3d31d8ed&lang=scss&scoped=true&"
import style1 from "./data.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d31d8ed",
  null
  
)

export default component.exports